import doc                      from '@widesk-core/decorators/doc';
import model                    from '@widesk-core/decorators/model';
import NetworkServiceModel      from '@/models/NetworkServiceModel';

@model.urnResource('relation_request_status')
@doc.path('/relation_request_statuses/{?id}')
export default class RelationRequestStatusModel extends NetworkServiceModel {
	private declare _tsFilters: {
		"id": id;
	};

	private declare _tsSorts: {
		'createdAt': string;
		'id': string;
		'updatedAt': string;
	};

	get reference(): RelationRequestStatusReference {
		return this.get('reference');
	}

	public getLabel(locale: 'en' | 'fr') {
		switch (this.reference) {
			case 'accepted':
				return locale === 'en' ? 'accepted' : 'acceptée';
			case 'canceled':
				return locale === 'en' ? 'canceled' : 'annulée';
			case 'expired':
				return locale === 'en' ? 'expired' : 'expirée';
			case 'pending':
				return locale === 'en' ? 'pending' : 'en attente';
		}
	}

	public get color() {
		switch (this.reference) {
			case 'accepted':
				return 'green';
			case 'canceled':
				return 'red';
			case 'expired':
				return 'gray';
			case 'pending':
				return 'orange';
		}
	}
}